export const MODAL_EXCLUSION_URIS = String(process.env.GATSBY_MODAL_EXCLUSION_URIS).split(',');
